import { observer } from 'mobx-react-lite';
import Toolbar from '../../components/Toolbar';
import { formatDate, formatMoney } from '../../utils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DetailInfoElement from '../../components/DetailInfoItem';
import { useHistory } from 'react-router-dom';
import Button from '../../components/Button';
import PopupConfirm from '../../components/PopupConfirm';
import autoPaymentStore, { AutoPaymentStore } from 'src/stores/AutoPaymentStore';
import { PolicyDetail } from '../../models/PolicyDetail';
import { FORMAT_DATE_YYYY_MM_DD } from '../../constants';

interface CancelRegisterProps {
  store: AutoPaymentStore;
}

type NullAble<T>  = T | null

export interface CancelRegisterState {
  policyNumber: NullAble<string>,
  autoDebitId: NullAble<string>,
  recordId: NullAble<string>
}

const CancelRegisterObserver = observer(({ store }: CancelRegisterProps) => {
  const [t] = useTranslation();
  const history = useHistory();

  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [detail, setDetail] = useState<PolicyDetail | null >(null);

  const _handleClose = () => {
    history.push('/');
  };

  const _handleBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if(!history?.location?.state?.['policyNumber']) {
      return
    }
    store.getPeriodicPolicy(
      {
        policyNumber: history.location.state['policyNumber'],
      }
    ).then((response: any) => {
      setDetail(response);
    }).catch(error => {});
  }, [history.location.state, store]);

  const _handleConfirm = () => {
    setVisibleModal(false);
    if(!history?.location?.state?.['policyNumber']) {
      return
    }
    const  { recordId, autoDebitId} = history.location.state as CancelRegisterState
    store.cancelRegisterAutoDebit({
        policyNumber: detail?.policyNum,
        phName: detail?.policyHolderName,
        recordId,
        autoDebitId
      })
      .then((data: any) => {
        const templateData = {
          cif: data.cif,
          requestType: data.requestType,
          merchant: {
            code: 'MBAL',
            name: 'Bảo hiểm Nhân thọ MB Ageas Life',
          },
          autoDebitId: data.autoDebitId,
          amount: data.amount,
          description: 'Hủy đăng ký thanh toán tự động BH định kỳ',
          frequencyUnit: null,
          schedulerPattern: null,
          dayOfAutoDebit: null,
          contractCode: data.contractCode,
          successMessage: 'Hủy thanh toán tự động thành công',
          metadata: '',
          paymentTransactionType: {
            name: 'Hủy thanh toán Phí bảo hiểm định kỳ',
            code: 'TTBHDK',
            allowCard: true,
            allowBNPL: false,
          },
          autoDebitStatus: data.autoDebitStatus,
          billerCustomerId: data.billerCustomerId,
          billerCustomerCode: data.billerCustomerId,
          createdDate: data.createdDate,
          requestId: data.requestId,
          payment: {
            firstPaymentAmount: null,
            firstPaymentDescription: null,
            paymentTransactionStatus: null,
          },
          autoDebitType: data.autoDebitType,
          retryDay: null,
          recordId: null,
        };

        if (window?.ReactNativeWebView) {
          window?.ReactNativeWebView?.postMessage(
            JSON.stringify({
              type: 'PAYMENT_HUB_AUTODEBIT',
              data: templateData,
            }),
          );
        }
      })
      .catch((error) =>{});
  };

  const showConfirmPopUp = () => {
    setVisibleModal(true);
  };

  return (
    <>
      <div className="screen-container ct-view bg-background fix-scroll">
        <Toolbar
          title={t('confirm_cancel_auto_payment_title')}
          showClose={true}
          onClose={_handleClose}
          onBack={_handleBack}
        />

        <div className="show-detail p-3">
          <div
            className={'show-detail-top border border-line border-radius-bottom mb-4 p-4 bg-white rounded'  }
          >
            <div className={'mb-6 font-bold'}>
              {t('cancel_auto_payment_confirm')}
            </div>
            <DetailInfoElement title={t('policy_number')} content={detail?.policyNum} />
            <DetailInfoElement title={t('main_product_name')} content={detail?.productName} />
            <DetailInfoElement title={t('policy_start_date_1')} content={formatDate(detail?.policyEffDate, FORMAT_DATE_YYYY_MM_DD)} />
            <DetailInfoElement title={t('pay_frequency')} content={detail?.payFreqText} />
            <DetailInfoElement title={t('fee_frequency')} content={
              detail?.periodicPremium && detail?.currency ?
                formatMoney(detail.periodicPremium)
                + ' '
                + detail?.currency
                : null
            } />
            <div className={'border-t pt-3 bg-white '}>
              <Button
                text={t('confirm')}
                extraClassName={'w-full'}
                onClick={() => showConfirmPopUp()}
              />
            </div>
          </div>

          <PopupConfirm
            showIcon={false}
            isHtmlContent={true}
            content={
            `<strong className={'text-base'}>${t('cancel_auto_payment')}</strong>`
            }
            visible={visibleModal}
            cancelTitle={t('cancel_action')}
            onCancel={() => setVisibleModal(false)}
            onOk={() => _handleConfirm()}
          />
        </div>
      </div>
    </>
  );
});

const CancelRegister = () => (
  <CancelRegisterObserver store={autoPaymentStore} />
);
export default CancelRegister;
